import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const DestructionTraceabilityPage = lazy(() =>
  import('./traceability/pages/DestructionTraceabilityPage').then((module) => ({
    default: module.DestructionTraceabilityPage,
  })),
);

const DestructionReceiptsPage = lazy(() =>
  import('./receipts/pages/DestructionReceiptsPage').then((module) => ({
    default: module.DestructionReceiptsPage,
  })),
);

const SunatCommunicationBatchListPage = lazy(() =>
  import('./batches/pages/SunatCommunicationBatchListPage').then((module) => ({
    default: module.SunatCommunicationBatchListPage,
  })),
);

const SunatCommunicationBatchesPage = lazy(() =>
  import('./batches/pages/SunatCommunicationBatchesPage').then((module) => ({
    default: module.SunatCommunicationBatchesPage,
  })),
);

const SunatCommunicationBatchDetailPage = lazy(() =>
  import('./batches/pages/SunatCommunicationBatchDetailPage').then((module) => ({
    default: module.SunatCommunicationBatchDetailPage,
  })),
);

export const destructionRoutes: RouteObject[] = [
  {
    path: 'destruction/traceability',
    element: createElement(ProtectedRoute, { view: 'destructionTraceability' }),
    children: [
      { index: true, element: createElement(DestructionTraceabilityPage) },
      { path: ':identifier', element: createElement(DestructionTraceabilityPage) },
    ],
  },
  {
    path: 'desmedro/recepcion',
    element: createElement(ProtectedRoute, { view: 'destructionReceipts' }),
    children: [{ index: true, element: createElement(DestructionReceiptsPage) }],
  },
  {
    path: 'comunicaciones-sunat',
    element: createElement(ProtectedRoute, { view: 'sunatCommunicationBatches' }),
    children: [
      { index: true, element: createElement(SunatCommunicationBatchListPage) },
      { path: 'nuevo', element: createElement(SunatCommunicationBatchesPage) },
      {
        path: ':id',
        element: createElement(ProtectedRoute, { view: 'sunatCommunicationBatchDetail' }),
        children: [{ index: true, element: createElement(SunatCommunicationBatchDetailPage) }],
      },
    ],
  },
];
